import React, { Component } from 'react'
import { styles } from '../styles'
import withStyles from 'material-ui/styles/withStyles'
import withTheme from 'material-ui/styles/withTheme'
import {compose} from 'redux'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Typography from 'material-ui/Typography'
import {firebaseConnect, isEmpty} from 'react-redux-firebase'
import {connect} from 'react-redux'
import Avatar from 'material-ui/Avatar'
import ClickAwayListener from 'material-ui/utils/ClickAwayListener'
import { Manager, Target, Popper } from 'react-popper'
import Paper from 'material-ui/Paper'
import classNames from 'classnames'
import Grow from 'material-ui/transitions/Grow'
import { MenuItem, MenuList } from 'material-ui/Menu'

class AppBarContainer extends Component {
    state = {
        menuOpen: false
    }
    handleMenuClick = () => {
        this.setState({menuOpen: !this.state.menuOpen})
    }
    handleClose = () => {
        if (!this.state.menuOpen) {
          return;
        }
    
        // setTimeout to ensure a close event comes after a target click event
        this.timeout = setTimeout(() => {
          this.setState({ menuOpen: false });
        });
      };
    render() {
        //console.log('-----APPBAR PROPS-----', this.props)
        return (
            <div>
                <AppBar style={{position: "static", zIndex: "1000"}}>
                    <Toolbar>
                    {/*
                        <IconButton className={this.props.classes.menuButton} color="secondary" aria-label="Menu">
                            <MenuIcon />
                        </IconButton>*/
                    }
                    <Typography variant="title" color="inherit" style={{flex: 1}}>
                        <img src="white-logo.svg" alt="logo" height="40px"/>
                    </Typography>
                    {isEmpty(this.props.auth)?null:
                        <Manager>
                            <Target>
                            {/*<Button
                                aria-owns={open ? 'menu-list' : null}
                                aria-haspopup="true"
                                onClick={this.handleClick}
                            >
                                Toggle Menu
                            </Button>*/}
                                <Avatar
                                    //onClick={()=>this.props.firebase.logout()}
                                    
                                    aria-owns={this.state.menuOpen ? 'menu-list' : null}
                                    aria-haspopup="true"
                                    onClick={this.handleMenuClick}
                                    alt={this.props.auth.displayName} src={this.props.auth.photoURL} style={{height: '40px', cursor: 'pointer'}}/>
                                </Target>
                            <Popper
                            placement="left"
                            eventsEnabled={this.state.menuOpen}
                            className={classNames({ [this.props.classes.popperClose]: !this.state.menuOpen })}
                            >
                            <ClickAwayListener onClickAway={this.handleClose}>
                                <Grow in={this.state.menuOpen} id="menu-list" style={{ transformOrigin: '0 0 0' }}>
                                <Paper>
                                    <MenuList role="menu">
                                    <MenuItem onClick={this.handleClose}>ข้อมูลส่วนตัว</MenuItem>
                                    <MenuItem onClick={()=>this.props.firebase.logout()}>ออกจากระบบ</MenuItem>
                                    </MenuList>
                                </Paper>
                                </Grow>
                            </ClickAwayListener>
                            </Popper>
                        </Manager>
                }
                    </Toolbar>
                </AppBar>
            </div>
        )
    }
}

export default compose(
    firebaseConnect(),
    withTheme(),
    withStyles(styles),
    connect(
        ({firebase: {auth}}) => ({auth})
    ))(AppBarContainer)


// WEBPACK FOOTER //
// ./src/main/AppBarContainer.js